import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HashRouter as Router, Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import { ROUTE_PATHS } from "@/lib/index";
import Home from "@/pages/Home";
import Departments from "@/pages/Departments";
import Admissions from "@/pages/Admissions";
import Faculty from "@/pages/Faculty";
import News from "@/pages/News";
import Regulations from "@/pages/Regulations";
import Contact from "@/pages/Contact";
import ProgramDetail from "@/pages/ProgramDetail";
import Accreditations from "@/pages/Accreditations";
import Admin from "@/pages/Admin";

const queryClient = new QueryClient();

const App = () => {
  useEffect(() => {
    document.documentElement.setAttribute('dir', 'rtl');
    document.documentElement.setAttribute('lang', 'ar');
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <Router>
          <Routes>
            <Route path={ROUTE_PATHS.HOME} element={<Home />} />
            <Route path={ROUTE_PATHS.DEPARTMENTS} element={<Departments />} />
            <Route path={ROUTE_PATHS.ADMISSIONS} element={<Admissions />} />
            <Route path={ROUTE_PATHS.FACULTY} element={<Faculty />} />
            <Route path={ROUTE_PATHS.NEWS} element={<News />} />
            <Route path={ROUTE_PATHS.REGULATIONS} element={<Regulations />} />
            <Route path={ROUTE_PATHS.CONTACT} element={<Contact />} />
            <Route path={ROUTE_PATHS.ACCREDITATIONS} element={<Accreditations />} />
            <Route path={ROUTE_PATHS.PROGRAM_DETAIL} element={<ProgramDetail />} />
            <Route path={ROUTE_PATHS.ADMIN} element={<Admin />} />
          </Routes>
        </Router>
      </TooltipProvider>
    </QueryClientProvider>
  );
};

export default App;